import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { orderBy } from 'lodash'

import Selector from 'modules/core/components/Selector'
import i18n from 'modules/core/lib/i18n'

import { useTags } from 'modules/ats/hooks/tags/useTags'

interface Props {
  value: number[]
  onChange: (newValue: number[]) => void
}

export const TagsSelector = ({ value, onChange }: Props) => {
  const { loading, tags } = useTags()
  const orderedByChecked = orderBy(tags, (tag) => (value.includes(tag?.id) ? 0 : 1))

  return (
    <Selector.Popover
      placeholder={i18n.t('ats.tags.selector.placeholder')}
      searchPlaceholder={i18n.t('common.search')}
      blankLabel={i18n.t('ats.tags.selector.blank_label')}
      value={value}
      // eslint-disable-next-line no-type-assertion/no-type-assertion
      onChange={(values: unknown) => onChange(values as number[])}
      isMultiSelect
      isDisabled={loading}
      footer={
        value.length > 0 ? (
          <Box alignItems="flexEnd">
            <Button type="secondary" onClick={() => onChange([])}>
              {i18n.t('ats.tags.selector.clear_selection')}
            </Button>
          </Box>
        ) : undefined
      }
    >
      {orderedByChecked.map((tag) => (
        <Selector.Option key={tag.name} value={tag.id} label={tag.name} searchValue={tag.name}>
          {tag.name}
        </Selector.Option>
      ))}
    </Selector.Popover>
  )
}
